import React from 'react';
import { Button } from '../ui/button';

export const ProblemViewModal = ({ handlePrintProblem, selectedProblemForView, setSelectedProblemForView, setShowProblemModal, showProblemModal }) => (
  <>
    {showProblemModal && selectedProblemForView && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-start mb-4">
              <h2 className="text-2xl font-bold text-gray-900">{selectedProblemForView.name}</h2>
              <button
                onClick={() => {
                  setShowProblemModal(false);
                  setSelectedProblemForView(null);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="prose max-w-none">
              <div className="whitespace-pre-wrap text-gray-700 leading-relaxed">
                {selectedProblemForView.overview}
              </div>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <Button
                variant="outline"
                onClick={() => {
                  setShowProblemModal(false);
                  setSelectedProblemForView(null);
                }}
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  handlePrintProblem(selectedProblemForView);
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                Print
              </Button>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
);
